<app-navigation></app-navigation>

<main>
  <app-about></app-about>
  <app-awards></app-awards>
  <app-skills></app-skills>
  <app-chess></app-chess>
</main>
